// extracted by mini-css-extract-plugin
export default {"container":"DiceSelector_container__om4go","selectorContent":"DiceSelector_selectorContent__kM9+T","dice":"DiceSelector_dice__hyY6p","count":"DiceSelector_count__wHwiS"};